import React, { useState, useEffect } from "react";
import useStyles from "../../Common/Style/FormStyle";
import http from "../../Common/RestAPIHandler";
import {
  Divider,
  Typography,
  Paper,
  Grid,
  IconButton,
  Table,
  TableRow,
  TableCell,
  TableHead,
  Snackbar,
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import FilterNoneIcon from "@material-ui/icons/FilterNone";
import { onCopy } from "../../Common/TableUtility";
import Alert from "@material-ui/lab/Alert";
import DataMappings from "../DataMappings";
import ScreenLoader from "../../Common/Loader";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

import EmployeeForm from "./EmployeeForm";
import Drawer from "@material-ui/core/Drawer";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import CreateIcon from "@material-ui/icons/Create";
import { EmployeesLang } from "../../Common/Languages";

const EmployeeDetails = (props) => {
  const classes = useStyles();
  const { id } = props.match.params;
  var { employeeId } = props.match.params;
  const [employee, setEmployee] = useState({});
  const [dataMappings, setDataMappings] = useState([]);
  const [credentials, setCredentials] = useState([]);
  const [message, setMessage] = useState();
  const [loading, setLoading] = useState(true);
  const lang = localStorage.getItem("languages");
  useEffect(() => {
    if (props.objectId) {
      employeeId = props.objectId;
    }
    http.Get(
      `company_employees/${employeeId}`,
      (employee) => {
        setEmployee(employee);
        http.Get(
          `data_mappings?from_id=${employee.id}`,
          (data) => {
            setDataMappings(data);
            http.Get(
              `employee/credential/?employee=${employee.id}`,
              (credentials) => {
                setCredentials(credentials);
                setLoading(false);
              },
              () => {}
            );
          },
          () => {}
        );
      },
      () => {}
    );
  }, []);

  const [open, setOpen] = useState(false);
  const [width, setWidth] = useState(400);
  const [startX, setStartX] = useState();
  const [endX, setEndX] = useState();

  const onDragStart = (e) => {
    setStartX(e.screenX);
  };

  const onDragEnd = (e) => {
    setEndX(e.screenX);
  };

  useEffect(() => {
    if(startX && endX){
      setWidth(width + startX - endX);
    }
  }, [startX, endX]);
  
  useEffect(() => {
    const vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    setWidth(vw * 0.8);
  }, [window.innerWidth]);

  const handleObjectSubmit = () => {
    window.location.reload(false);
  };

  return (
    <>
      {loading && <ScreenLoader />}
      {!loading && (
        <Grid container spacing={1} className={classes.paper}>
          <Grid item xs={10}>
            <Typography
              variant="h6"
              component="h6"
              classes={{ h6: classes.title }}
              style={{ paddingTop: 10, paddingBottom: 10 }}
            >
              {employee.employee_name}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <div style={{ paddingTop: 10, float: "right" }}>
              <IconButton
                className={classes.iconButtonColored}
                onClick={() => {
                  if (props.onClose) {
                    props.onClose();
                  } else {
                    props.history.push(
                      process.env.PUBLIC_URL + `/company/${id}/employees`
                    );
                  }
                }}
              >
                <HighlightOffIcon />
              </IconButton>
            </div>
          </Grid>
          <Grid item xs={12}>
            <Divider className={classes.divider}/>
          </Grid>
          <Grid item xs={10}>
            <Paper >
              <div
                style={{
                  maxHeight: "calc(100vh - 280px)",
                  minHeight: "calc(100vh - 280px)",
                  overflowY: "auto",
                  overflowX: "auto",
                  marginLeft: 10,
                  padding: 10,
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <span style={{ fontWeight: "bold" }}>{EmployeesLang.EMPLOYEENAME[lang]}</span>
                  </Grid>
                  <Grid item xs={8}>
                    {employee.employee_name}                 
                    
                    <IconButton
                      className={classes.iconButtonColored}
                      style={{float:"right"}}
                      onClick={() => {
                          setOpen(true);
                      }}
                    >
                      <CreateIcon />
                    </IconButton>
                    <Drawer
                      anchor="right"
                      open={open}
                      onClose={() => setOpen(false)}
                      disableEnforceFocus
                      classes={{
                        paper: classes.drawerForm,
                      }}
                    >
                      <div style={{ width: width }}>
                        <table>
                          <tbody>
                            <tr>
                              <td
                                draggable
                                style={{ cursor: "ew-resize" }}
                                onDragStart={onDragStart}
                                onDragEnd={onDragEnd}
                              >
                                <DragIndicatorIcon />
                              </td>
                              <td width="100%">
                                <EmployeeForm
                                  {...props}
                                  closeOpen={(open) => setOpen(open)}
                                  objectId={props.objectId}
                                  handleObjectSubmit={handleObjectSubmit}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Drawer>

                  </Grid>
                  <Grid item xs={4}>
                    <span style={{ fontWeight: "bold" }}>{EmployeesLang.EMAIL[lang]}</span>
                  </Grid>
                  <Grid item xs={8}>
                    {employee.email}
                  </Grid>
                  <Grid item xs={4}>
                    <span style={{ fontWeight: "bold" }}>{EmployeesLang.SITE[lang]}</span>
                  </Grid>
                  <Grid item xs={8}>
                    {employee.site_name}
                  </Grid>
                  <Grid item xs={4}>
                    <span style={{ fontWeight: "bold" }}>{EmployeesLang.PHONENUMBER[lang]}</span>
                  </Grid>
                  <Grid item xs={8}>
                    {employee.phone_number}
                  </Grid>
                  <Grid item xs={4}>
                    <span style={{ fontWeight: "bold" }}>{EmployeesLang.MOBILE[lang]}</span>
                  </Grid>
                  <Grid item xs={8}>
                    {employee.mobile}
                  </Grid>
                  <Grid item xs={4}>
                    <span style={{ fontWeight: "bold" }}>{EmployeesLang.COUNTRYCODE[lang]}</span>
                  </Grid>
                  <Grid item xs={8}>
                    {employee.country_code}
                  </Grid>
                  <Grid item xs={4}>
                    <span style={{ fontWeight: "bold" }}>{EmployeesLang.SHORTNOTE[lang]}</span>
                  </Grid>
                  <Grid item xs={8}>
                    {employee.short_note}
                  </Grid>
                  <Grid item xs={4}>
                    <span style={{ fontWeight: "bold" }}>{EmployeesLang.WORKSTATION[lang]}</span>
                  </Grid>
                  <Grid item xs={8}>
                    {employee.work_station}
                  </Grid>
                  <Grid item xs={4}>
                    <span style={{ fontWeight: "bold" }}>{EmployeesLang.CATEGORY[lang]}</span>
                  </Grid>
                  <Grid item xs={8}>
                    {employee.category_name}
                  </Grid>
                  <Grid item xs={4}>
                    <span style={{ fontWeight: "bold" }}>{EmployeesLang.PORTALROLE[lang]}</span>
                  </Grid>
                  <Grid item xs={8}>
                    {employee.role_name}
                  </Grid>
                  <Grid item xs={4}>
                    <span style={{ fontWeight: "bold" }}>{EmployeesLang.ACTIVE[lang]}</span>
                  </Grid>
                  <Grid item xs={8}>
                    {employee.status && <CheckIcon />}
                  </Grid>
                  <Grid item xs={4}>
                    <span style={{ fontWeight: "bold" }}>{EmployeesLang.HIDDEN[lang]}</span>
                  </Grid>
                  <Grid item xs={8}>
                    {employee.is_hidden && <CheckIcon />}
                  </Grid>
                  <Grid item xs={4}>
                    <span style={{ fontWeight: "bold" }}>{EmployeesLang.BILLINGCONTACT[lang]}</span>
                  </Grid>
                  <Grid item xs={8}>
                    {employee.is_billing_contact && <CheckIcon />}
                  </Grid>
                  <Grid item xs={12}>
                    <span style={{ fontWeight: "bold" }}>{EmployeesLang.CREDENTIALS[lang]}</span>
                    <Divider />
                  </Grid>
                  <Grid item xs={12}>
                    <Snackbar
                      open={Boolean(message)}
                      autoHideDuration={3000}
                      onClose={() => {
                        setMessage(null);
                      }}
                      anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    >
                      <Alert
                        onClose={() => {
                          setMessage(null);
                        }}
                        severity="success"
                        elevation={6}
                        variant="filled"
                      >
                        {message}
                      </Alert>
                    </Snackbar>
                    <Table classes={{ root: classes.tables }}>
                      <TableHead>
                        <TableCell className={classes.tableCellHeader}>
                        {EmployeesLang.CATEGORY[lang]}
                        </TableCell>
                        <TableCell className={classes.tableCellHeader}>
                        {EmployeesLang.DESCRIPTION[lang]}
                        </TableCell>
                        <TableCell className={classes.tableCellHeader}>
                        {EmployeesLang.USERNAME[lang]}
                        </TableCell>
                        <TableCell className={classes.tableCellHeader}>
                        {EmployeesLang.PASSWORD[lang]}
                        </TableCell>
                        <TableCell className={classes.tableCellHeader}>
                        {EmployeesLang.WEBSITE[lang]}
                        </TableCell>
                      </TableHead>
                      {credentials.map((credential) => {
                        return (
                          <TableRow className={classes.tableRow}>
                            <TableCell className={classes.tableCell}>{credential.category_name}</TableCell>
                            <TableCell className={classes.tableCell}>{credential.description}</TableCell>
                            <TableCell className={classes.tableCell}>
                              <FilterNoneIcon
                                className={classes.iconButtonColored}
                                fontSize="small"
                                style={{
                                  cursor: "pointer",
                                  // color: "#a4a4a4",
                                  width: 15,
                                  verticalAlign: "bottom",
                                }}
                                onClick={() => {
                                  onCopy(props, credential, "username");
                                  setMessage(EmployeesLang.UsernameCopied[lang]);
                                }}
                              />
                              &nbsp;&nbsp;{credential.username}
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                              <FilterNoneIcon
                                className={classes.iconButtonColored}
                                fontSize="small"
                                style={{
                                  cursor: "pointer",
                                  // color: "#a4a4a4",
                                  width: 15,
                                  verticalAlign: "bottom",
                                }}
                                onClick={() => {
                                  onCopy(props, credential, "password");
                                  setMessage(EmployeesLang.PasswordCopied[lang]);
                                }}
                              />
                              &nbsp;&nbsp;
                              <span
                                className={classes.cursor}
                                onClick={(e) => {
                                  if (e.target.innerHTML === "············") {
                                    e.target.innerHTML = String(credential.password).replaceAll("<","&lt;").replaceAll(">","&gt;");
                                  } else {
                                    e.target.innerHTML = "············";
                                  }
                                }}
                              >
                                ············
                              </span>
                            </TableCell>
                            <TableCell className={classes.tableCell}>{credential.website}</TableCell>
                          </TableRow>
                        );
                      })}
                    </Table>
                  </Grid>
                </Grid>
              </div>
            </Paper>
            <Divider />
          </Grid>
          <Grid item xs={2}>
            <Paper>
              <div
                style={{
                  maxHeight: "calc(100vh - 280px)",
                  minHeight: "calc(100vh - 280px)",
                  overflowY: "auto",
                  overflowX: "auto",
                  marginLeft: 10,
                  padding: 10,
                }}
              >
                <p style={{ fontWeight: "bold" }}>{EmployeesLang.RelatedEntries[lang]}:</p>
                <DataMappings
                  {...props}
                  dataMappings={dataMappings}
                  setDataMappings={null}
                />
              </div>
            </Paper>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default EmployeeDetails;
